import React, { Component } from 'react';
import PaymentSuccessPage from '../../client/components/paymentSuccessPage';
import { withRouter } from 'react-router-dom';
//import get from 'lodash/get';
/* eslint-disable no-console */


class PaymentConfirmation extends Component {
  render () {
    // eslint-disable-next-line react/prop-types
    //const matches = get(this.props, 'location.search', '').match(/status=([^&]*)/);
    // eslint-disable-next-line no-unused-vars
    //const status = get(matches, '[1]', '');
    //console.log('>>>>', status);

    return (
      <PaymentSuccessPage />
    );
  }
}

export default withRouter(PaymentConfirmation) ;